export const DATE_FORMATS = {
  DATE: 'yyyy-MM-dd',
  TIME: 'HH:mm',
  DATE_TIME: 'yyyy-MM-dd HH:mm',
} as const;

export type DateFormatType = keyof typeof DATE_FORMATS;
